import Rte from '../utils/Rte';

export default class StaticPage {
  constructor(section) {
    this.el = section.el;
    this.rtes = [];

    this.el.querySelectorAll('[data-rich-text-area]').forEach(el => this.rtes.push(new Rte({ el })));
  }

  onSectionUnload() {
    this.rtes.forEach(rte => rte.unload());
  }
}
